import { BehaviorSubject } from 'rxjs';
import { Service } from '../../symphony';
import {
	ErrorStatusCodes,
	IConfigs, IModelConfig, IPrompt, Message,
} from './aIChatPlaygroundInterface';
import { IMaterialHeader } from '../../api/private/learn-engine-api/learn-engine-api.interface';

@Service()
export class AIChatPlaygroundStore {
	public conversationId = new BehaviorSubject<string>(null);

	public configs = new BehaviorSubject<IConfigs>(null);

	public conversation = new BehaviorSubject<Message[]>([]);

	public initialConversation = new BehaviorSubject<Message[]>([]);

	public initialPrompts = new BehaviorSubject<IPrompt[]>([]);

	public isResponseLoading = new BehaviorSubject<boolean>(false);

	public isRegenerating = new BehaviorSubject<boolean>(false);

	public modelConfigs = new BehaviorSubject<IModelConfig[]>([]);

	public isInitialized = new BehaviorSubject<boolean>(false);

	public isInitialState = new BehaviorSubject<boolean>(true);

	public errorStatusCode = new BehaviorSubject<ErrorStatusCodes>(null);

	public materialHeader = new BehaviorSubject<IMaterialHeader>(null);
}
